import { createClient } from '@supabase/supabase-js'

const supabaseUrl     = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

// Override the Web Locks API to prevent lock conflicts in the Supabase client
const noopLock: LockManager = {
  request: async (
    _name: string,
    _optionsOrCallback: any,
    callback?: any
  ) => {
    const fn = callback ?? _optionsOrCallback
    return fn({ name: _name, mode: 'exclusive' })
  },
  query: async () => ({
    held:    [],
    pending: [],
  }),
}

// Patch navigator.locks before creating the client so Supabase never acquires a real lock
if (typeof window !== 'undefined') {
  try {
    Object.defineProperty(navigator, 'locks', {
      value:        noopLock,
      writable:     true,
      configurable: true,
    })
  } catch (e) {
    console.warn('Could not patch navigator.locks:', e)
  }
}

export const supabase = createClient(
  supabaseUrl,
  supabaseAnonKey,
  {
    auth: {
      persistSession:     true,
      autoRefreshToken:   true,
      detectSessionInUrl: true,
      storageKey:         'pantry-auth',
    },
    global: {
      fetch: (url, options) => fetch(url, options),
    },
  }
)
